if (!window.__faqRichtextIsolationLoaded) {
  window.__faqRichtextIsolationLoaded = true;

  const FAQ_RICHTEXT_SELECTOR = '[data-faq-richtext]';
  const BLOCKED_NODE_SELECTOR = [
    'base',
    'meta',
    'title',
    'script',
    'link[rel="stylesheet"]',
    'link[rel="preconnect"]',
    'link[rel="preload"]'
  ].join(', ');
  const BASE_STYLES = `
    :host {
      display: block;
      color: inherit;
      font-family: inherit;
      font-size: inherit;
      font-weight: inherit;
      line-height: inherit;
    }

    *, *::before, *::after {
      box-sizing: border-box;
    }

    img, video, iframe, canvas, svg {
      max-width: 100%;
    }

    img, video, canvas {
      height: auto;
    }

    p {
      margin: 0;
    }

    table {
      max-width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
    }

    a {
      color: inherit;
    }
  `;

  function createFragment(html, options = {}) {
    const template = document.createElement('template');
    template.innerHTML = html;
    template.content.querySelectorAll(BLOCKED_NODE_SELECTOR).forEach((node) => node.remove());

    if (options.removeStyles) {
      template.content.querySelectorAll('style').forEach((node) => node.remove());
    }

    return template.content;
  }

  function isolateRichtext(host) {
    if (!host || host.dataset.faqRichtextIsolated === 'true') return;

    const html = host.innerHTML;
    if (!html.trim()) {
      host.dataset.faqRichtextIsolated = 'true';
      return;
    }

    if (typeof host.attachShadow !== 'function') {
      const fragment = createFragment(html, { removeStyles: true });
      host.innerHTML = '';
      host.appendChild(fragment);
      host.dataset.faqRichtextIsolated = 'true';
      return;
    }

    const fragment = createFragment(html);
    host.innerHTML = '';

    const shadow = host.shadowRoot || host.attachShadow({ mode: 'open' });
    while (shadow.firstChild) {
      shadow.removeChild(shadow.firstChild);
    }

    const style = document.createElement('style');
    style.textContent = BASE_STYLES;
    shadow.appendChild(style);
    shadow.appendChild(fragment);

    host.dataset.faqRichtextIsolated = 'true';
  }

  function initFaqRichtextIsolation(root = document) {
    if (!root || typeof root.querySelectorAll !== 'function') return;

    if (root instanceof Element && root.matches(FAQ_RICHTEXT_SELECTOR)) {
      isolateRichtext(root);
    }

    root.querySelectorAll(FAQ_RICHTEXT_SELECTOR).forEach((node) => {
      isolateRichtext(node);
    });
  }

  window.initFaqRichtextIsolation = initFaqRichtextIsolation;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initFaqRichtextIsolation(document);
    });
  } else {
    initFaqRichtextIsolation(document);
  }
}
